export enum DocumentType {
  AccreditedRegister = 'Accredited Register',
  ProfessionalBody = 'Professional Body'
}
